const RAW_PUBLIC_URL = process.env.PUBLIC_URL || '/';

// CRA often sets PUBLIC_URL to "." for relative asset paths.
// Router basename cannot be "."; normalize to root semantics.
const normalizePublicUrl = (value) => {
  const trimmed = (value || '').trim();
  if (!trimmed || trimmed === '/' || trimmed === '.' || trimmed === './') {
    return '';
  }
  return trimmed.replace(/\/$/, '');
};

const PUBLIC_URL = normalizePublicUrl(RAW_PUBLIC_URL);

export const config = {
  publicUrl: PUBLIC_URL,
  apiBaseUrl: `${PUBLIC_URL}/api`,
  redirectOnUnauthorized: PUBLIC_URL || '/',
};

console.log('Config loaded:', config);

export default config;
